// tslint:disable:max-line-length
import * as React from 'react';
import { SixteenIcon } from '../../ui/icon/icons/16';
import { CianGroupIcon } from '../../ui/icon/icons/cian-group';

import classNames from 'classnames';

const styles = require('./footer.css');

interface IFooterProps {
  currentYear: number;
}

export class Footer extends React.PureComponent<IFooterProps, object> {
  public render() {
    return (
      <footer className={styles['footer']}>
        <div className={styles['footer-top']}>
          <div className={styles['logo-wrapper']}>
            <CianGroupIcon iconClassName={styles.logo} />
            <p className={styles.leader}>Лидер онлайн-недвижимости России&#42;</p>
            <noindex>
              <div className={styles['footer-asterisk']}>
                &#42; по количеству посещений сайта cian.ru пользователями сети Интернет по данным LiveInternet в
                разделе «Недвижимость»
              </div>
            </noindex>
          </div>
          <div className={classNames(styles['link-wrapper'], styles['footer-top_item'])}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.cian.ru/" className={styles['link']}>
              cian.ru
            </a>
            &nbsp;— достоверные объявления о&nbsp;продаже и&nbsp;аренде жилой, загородной и&nbsp;коммерческой
            недвижимости
          </div>
          <div className={styles['footer-top_item']}>
            <span>
              <noindex>
                <span className={styles['link-wrapper']}>
                  <a
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    href="http://emls.ru/"
                    className={styles['link']}
                  >
                    emls.ru
                  </a>
                  &nbsp;— сайт недвижимости <span className={styles['inline_text']}>Санкт-Петербурга</span>
                </span>
              </noindex>
            </span>
          </div>
        </div>
        <div className={styles.copyright}>
          <span className={styles['copyright-text']}>© {this.props.currentYear}, ЦИАН ГРУПП</span>
          <SixteenIcon iconClassName={styles.age} />
        </div>
      </footer>
    );
  }
}
